export const DASHBOARD_PATH = 'b2b/account/view/quote/list';
export const Role = {
  ADMIN: 'ADMIN',
  PURCHASER: 'PURCHASER',
  UNKNOWN: 'UNKNOWN',
};

export class Constants {
  // tool tip constant for quote filter
  static PRINT_WITH_NO_PRICE = 'nopriceordiscounts';

  static PRINT_WITH_PRICE_DISCOUNT = 'priceanddiscounts';

  static PRINT_WITH_PRICE_ONLY = 'priceonly';

  static PENDING_QUOTE_STATUS = 'P';

  static ACTIVE_QUOTE_STATUS = 'A';

  static EXPIRED_QUOTE_STATUS = 'E';

  static IS_ONLINE_QUOTE = 'Digital';

  static IS_PA_QUOTE = 'ProAssist';

  static IS_VIEW_ONLY_QUOTE = 1;

  static IS_TRANSACT_ONLY_QUOTE = 2;

  static EXPIRED_QUOTE = 'expired';

  static TECHNICAL_ERROR =
    'We\'re sorry, there was a temporary technical issue. Please try again shortly';

  static DUPLICATE_QUOTE_ERROR =
    'We are not able to duplicate your quote at this time. Please try again shortly.';

  static HTTP_HEADERS_JSON = {
    'Content-Type': 'application/json',
    accept: 'application/json;charset=utf-8',
  };

  static QUOTE_QUICK_ADD_FAILURE =
    'Sorry, something went wrong on our end. Please try again.';

  static QUOTE_QUICK_ADD_SUCCESS =
    'Your items have been successfully added to your quote.';

  static QUOTE_QUICK_ADD_PARTIAL_SUCCESS =
  'Error: Some items couldn\'t be added to your quote. Review the issue below.';

  static QUOTE_QUICK_ADD_QTY_OVER_10000 = 'Quantity should be less than 10000.';

  static QUOTE_EMAIL_MESSAGE = 'Attached is your Quote from the Home Depot';

  static DELIVERY_FFM = ['STH', 'BODFS', 'Delivery'];

  static PROJECTS_SESSION_STORAGE_KEY = 'projects-active-tab';

  static QUOTE_PROJECT_ID = 'quote-project-id';
}
